var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-modal", {
    attrs: {
      title: _vm.type ? _vm.$t("新增部门") : _vm.$t("编辑部门"),
      visible: _vm.dialogVisible,
      okText: _vm.$t("确认"),
      cancelText: _vm.$t("取消")
    },
    on: {
      ok: _vm.handleSure,
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, [_c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      model: _vm.dataFrom,
      rules: _vm.dataRule,
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 18
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      prop: "orgType",
      label: _vm.$t("组织类型")
    }
  }, [_c("div", {
    staticStyle: {
      display: "flex"
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("组织类型")
    },
    model: {
      value: _vm.dataFrom.orgType,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "orgType", $$v);
      },
      expression: "dataFrom.orgType"
    }
  }, _vm._l(_vm.typeList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1), _vm.isAuth("customer.companyOrganizationStore") ? _c("a-button", {
    attrs: {
      type: "link"
    },
    on: {
      click: _vm.addOrgType
    }
  }, [_vm._v(_vm._s(_vm.$t("新增")))]) : _vm._e()], 1)]), _c("a-form-model-item", {
    attrs: {
      prop: "name",
      label: _vm.$t("部门名称")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("部门名称"),
      maxLength: 50
    },
    model: {
      value: _vm.dataFrom.name,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "name", $$v);
      },
      expression: "dataFrom.name"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "principal",
      label: _vm.$t("负责人")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("负责人"),
      maxLength: 50
    },
    model: {
      value: _vm.dataFrom.principal,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "principal", $$v);
      },
      expression: "dataFrom.principal"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "mobile",
      label: _vm.$t("负责人电话")
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("负责人电话")
    },
    model: {
      value: _vm.dataFrom.mobile,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "mobile", $$v);
      },
      expression: "dataFrom.mobile"
    }
  })], 1)], 1)], 1), _vm.typeShow ? _c("type-model", {
    ref: "typeForm",
    on: {
      cancel: function ($event) {
        _vm.typeShow = false;
      },
      ok: _vm.handleOk
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };